/*
  Vorelisse — 3D podyum sahnesi (Three.js r128 UMD)

  Ürünlerin sırayla öne çıktığı bir stüdyo podyumu. Öndeki parça en büyük,
  en net ve en aydınlık olan; yanlar geriye düşer, söner, odaktan çıkar.

  2026-08-18 revizyonu — "ucuz 3D" görüntüsünü veren üç şey kaldırıldı:
    1. Parlak kırmızı torus halka (ekranda ruj lekesi gibi duruyordu)
       → yerine podyum yüzeyine düşen yumuşak ışık havuzu.
    2. Sert kenarlı koni "spot ışığı" (üçgen bant olarak görünüyordu)
       → yerine dikey gradyanlı, kenarları eriyen ışık perdesi.
    3. Fotoğrafın karesini yuvarlak maskeyle gizleme numarası (kenarda
       hâle bırakıyordu) → yerine gerçek şeffaf PNG/WebP kesimler.
       Kesim olmayan görseller için eski maske yedek olarak duruyor.

  Ayrıca eklendi: zemine düşen temas gölgesi ve podyum üstünde sönen yansıma —
  ürünün havada asılı durmasını engelleyen, "oraya konmuş" hissini veren iki şey.

  <canvas data-jv-3d
          data-images="url1,url2,..."
          data-accent="#B3122B"
          data-align="right|center"></canvas>

  WebGL yoksa / hareket kısıtlıysa CSS poster yedeğine düşer.
*/
(function () {
  'use strict';

  function hasWebGL() {
    try {
      var c = document.createElement('canvas');
      return !!(
        window.WebGLRenderingContext &&
        (c.getContext('webgl') || c.getContext('experimental-webgl'))
      );
    } catch (e) {
      return false;
    }
  }

  function showFallback(canvas) {
    canvas.style.display = 'none';
    var stage = canvas.closest('[data-jv-3d-stage]');
    if (stage) stage.classList.add('jv-3d--fallback');
  }

  function loadImage(src) {
    return new Promise(function (resolve) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        resolve(img);
      };
      img.onerror = function () {
        resolve(null);
      };
      img.src = src;
    });
  }

  /* Görsel zaten kesim mi? Dört köşedeki alfaya bakılır: hepsi saydamsa
     maskeye gerek yok — maske uygulamak net kesimi bulanıklaştırırdı. */
  function isCutout(img) {
    try {
      var s = 32;
      var cv = document.createElement('canvas');
      cv.width = cv.height = s;
      var ctx = cv.getContext('2d');
      ctx.drawImage(img, 0, 0, s, s);
      var d = ctx.getImageData(0, 0, s, s).data;
      function a(x, y) {
        return d[(y * s + x) * 4 + 3];
      }
      return a(0, 0) < 12 && a(s - 1, 0) < 12 && a(0, s - 1) < 12 && a(s - 1, s - 1) < 12;
    } catch (e) {
      return false;
    }
  }

  function plainTexture(THREE, img) {
    /* Sahne dokuyu KARE bir düzleme geriyor (PlaneGeometry(PLANE, PLANE)) ve
       en-boy oranını kendisi düzeltmiyor. Kare OLMAYAN bir kesim verilirse
       ürün yatayda gerilip basık görünür — canlıda tam bu yaşandı.

       Burada kare olmayan görsel, saydam dolgulu kare bir tuvale ortalanarak
       normalleştiriliyor. Böylece hangi ölçüde kesim verilirse verilsin sahne
       onu bozmaz; kare gelenler ise ek işlem görmeden geçer. */
    if (img.width !== img.height) {
      var s = Math.max(img.width, img.height);
      var cv = document.createElement('canvas');
      cv.width = cv.height = s;
      cv.getContext('2d').drawImage(img, (s - img.width) / 2, (s - img.height) / 2);
      var square = new THREE.CanvasTexture(cv);
      square.anisotropy = 4;
      square.minFilter = THREE.LinearFilter;
      square.generateMipmaps = false;
      return square;
    }

    var tex = new THREE.Texture(img);
    tex.needsUpdate = true;
    tex.anisotropy = 4;
    tex.minFilter = THREE.LinearFilter;
    tex.generateMipmaps = false;
    return tex;
  }

  /* Yedek: arka planı olan fotoğraflar için eski yumuşak maske. */
  function maskedTexture(THREE, img) {
    var s = 1024;
    var cv = document.createElement('canvas');
    cv.width = cv.height = s;
    var ctx = cv.getContext('2d');
    var r = Math.max(s / img.width, s / img.height);
    var w = img.width * r,
      h = img.height * r;
    ctx.drawImage(img, (s - w) / 2, (s - h) / 2, w, h);
    ctx.globalCompositeOperation = 'destination-in';
    var g = ctx.createRadialGradient(s / 2, s / 2, s * 0.3, s / 2, s / 2, s * 0.5);
    g.addColorStop(0, 'rgba(0,0,0,1)');
    g.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, s, s);
    var tex = new THREE.CanvasTexture(cv);
    tex.anisotropy = 4;
    return tex;
  }

  /* Yumuşak radyal leke — ışık havuzu, gölge ve arka fon parıltısı hep bundan.
     stops: [[offset, alpha], ...] */
  function blobTexture(THREE, stops) {
    var s = 256;
    var cv = document.createElement('canvas');
    cv.width = cv.height = s;
    var ctx = cv.getContext('2d');
    var g = ctx.createRadialGradient(s / 2, s / 2, 0, s / 2, s / 2, s / 2);
    stops.forEach(function (st) {
      g.addColorStop(st[0], 'rgba(255,255,255,' + st[1] + ')');
    });
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, s, s);
    return new THREE.CanvasTexture(cv);
  }

  /* Dikey ışık perdesi: üstte yoğun, aşağı inerken eriyor; yanlarda da
     eriyor ki dikdörtgen kenarı hiç görünmesin. */
  function curtainTexture(THREE) {
    var w = 128,
      h = 256;
    var cv = document.createElement('canvas');
    cv.width = w;
    cv.height = h;
    var ctx = cv.getContext('2d');
    var v = ctx.createLinearGradient(0, 0, 0, h);
    v.addColorStop(0, 'rgba(255,255,255,0.85)');
    v.addColorStop(0.45, 'rgba(255,255,255,0.32)');
    v.addColorStop(1, 'rgba(255,255,255,0)');
    ctx.fillStyle = v;
    ctx.fillRect(0, 0, w, h);
    ctx.globalCompositeOperation = 'destination-in';
    var hgrad = ctx.createLinearGradient(0, 0, w, 0);
    hgrad.addColorStop(0, 'rgba(0,0,0,0)');
    hgrad.addColorStop(0.5, 'rgba(0,0,0,1)');
    hgrad.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.fillStyle = hgrad;
    ctx.fillRect(0, 0, w, h);
    return new THREE.CanvasTexture(cv);
  }

  function sprite(THREE, tex, color, size, opacity, blending) {
    var mat = new THREE.SpriteMaterial({
      map: tex,
      color: color,
      transparent: true,
      opacity: opacity,
      depthWrite: false,
      depthTest: false,
      blending: blending || THREE.NormalBlending
    });
    var sp = new THREE.Sprite(mat);
    sp.scale.set(size, size, 1);
    return sp;
  }

  function particles(THREE, count, color, spread) {
    var geo = new THREE.BufferGeometry();
    var pos = new Float32Array(count * 3);
    for (var i = 0; i < count; i++) {
      pos[i * 3] = (Math.random() - 0.5) * spread;
      pos[i * 3 + 1] = (Math.random() - 0.5) * spread;
      pos[i * 3 + 2] = (Math.random() - 0.5) * spread - 2;
    }
    geo.setAttribute('position', new THREE.BufferAttribute(pos, 3));
    var mat = new THREE.PointsMaterial({
      color: color,
      size: 0.022,
      transparent: true,
      opacity: 0.35,
      depthWrite: false,
      blending: THREE.AdditiveBlending
    });
    return new THREE.Points(geo, mat);
  }

  function smoothstep(a, b, x) {
    var t = Math.min(1, Math.max(0, (x - a) / (b - a)));
    return t * t * (3 - 2 * t);
  }

  function init(canvas) {
    var THREE = window.THREE;
    var accent = canvas.getAttribute('data-accent') || '#B3122B';
    var alignRight = (canvas.getAttribute('data-align') || 'center') === 'right';
    var srcs = (canvas.getAttribute('data-images') || '')
      .split(',')
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean);

    if (!srcs.length) {
      showFallback(canvas);
      return;
    }

    var accentColor = new THREE.Color(accent);
    var warmWhite = new THREE.Color('#FFEFE2');

    var renderer = new THREE.WebGLRenderer({ canvas: canvas, alpha: true, antialias: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));

    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(42, 1, 0.1, 100);
    camera.position.set(0, 0.35, 7);

    scene.add(new THREE.AmbientLight(0xffffff, 0.9));
    var key = new THREE.PointLight(0xfff0e4, 1.35, 40);
    key.position.set(1.2, 4.2, 5);
    scene.add(key);
    var fill = new THREE.PointLight(accentColor, 0.55, 30);
    fill.position.set(-3, 0.5, 3);
    scene.add(fill);

    /* Geniş ekranda metin solda, podyum sağda — yan yana.
       Dar ekranda sahne ortalanır: orada canvas metnin ARKASINDA değil,
       kendi bloğu olarak metnin ÜSTÜNDE duruyor (bölümün mobil CSS'i
       canvas'ı position: relative yapıyor), yani çakışma olmuyor. */
    function targetOX() {
      return alignRight && window.innerWidth >= 750 ? 1.95 : 0;
    }

    var world = new THREE.Group();
    world.position.x = targetOX();
    scene.add(world);

    var softBlob = blobTexture(THREE, [
      [0, 0.95],
      [0.35, 0.4],
      [0.7, 0.1],
      [1, 0]
    ]);
    var tightBlob = blobTexture(THREE, [
      [0, 1],
      [0.28, 0.7],
      [0.62, 0.16],
      [1, 0]
    ]);

    var FLOOR_Y = -1.62;

    /* Arka fon parıltısı — ürünün arkasında duran sıcak hale. Sahneye
       derinlik verir, düz siyah zemini kırar. */
    var backGlow = sprite(THREE, softBlob, accentColor, 7.6, 0.34, THREE.AdditiveBlending);
    backGlow.position.set(0, 0.35, -3.4);
    world.add(backGlow);

    /* Üstten inen ışık perdesi — koni değil, kenarları eriyen bir perde. */
    var curtain = new THREE.Mesh(
      new THREE.PlaneGeometry(3.4, 5),
      new THREE.MeshBasicMaterial({
        map: curtainTexture(THREE),
        color: warmWhite,
        transparent: true,
        opacity: 0.1,
        depthWrite: false,
        blending: THREE.AdditiveBlending,
        side: THREE.DoubleSide
      })
    );
    curtain.position.set(0, 0.9, -1.2);
    world.add(curtain);

    /* PODYUM YOK — bilerek.
       Ürünün kendi yuvarlak tabanı zaten var; altına bir de silindir koymak
       "tabanın üstünde taban" oluyordu ve ekranda uçan daire gibi duruyordu.
       Yerine yalnız zemine düşen ışık havuzu var: dar, sönük, kenarsız.
       Zemini çizmeden zemin hissi verir. */
    var pool = new THREE.Mesh(
      new THREE.PlaneGeometry(2.4, 2.4),
      new THREE.MeshBasicMaterial({
        map: softBlob,
        color: warmWhite,
        transparent: true,
        opacity: 0.055,
        depthWrite: false,
        blending: THREE.AdditiveBlending
      })
    );
    pool.rotation.x = -Math.PI / 2;
    pool.position.set(0, FLOOR_Y - 0.02, 0);
    world.add(pool);

    scene.add(particles(THREE, 120, warmWhite, 13));

    var planes = [];
    var shadows = [];
    var mirrors = [];
    var N = 0;
    var PLANE = 2.72;
    var PAD = 0.055; // kesim görselindeki kenar boşluğu oranı

    Promise.all(srcs.map(loadImage)).then(function (imgs) {
      imgs = imgs.filter(Boolean);
      if (!imgs.length) {
        showFallback(canvas);
        return;
      }
      N = imgs.length;

      imgs.forEach(function (img) {
        var tex = isCutout(img) ? plainTexture(THREE, img) : maskedTexture(THREE, img);

        var mesh = new THREE.Mesh(
          new THREE.PlaneGeometry(PLANE, PLANE),
          new THREE.MeshBasicMaterial({ map: tex, transparent: true, depthWrite: false })
        );
        mesh.position.set(0, 0, -8);
        world.add(mesh);
        planes.push(mesh);

        /* Yansıma: aynı doku, dikey çevrilmiş, çok sönük. Ürünün podyuma
           gerçekten değdiği hissi buradan gelir. */
        var mirror = new THREE.Mesh(
          new THREE.PlaneGeometry(PLANE, PLANE),
          new THREE.MeshBasicMaterial({
            map: tex,
            transparent: true,
            opacity: 0,
            depthWrite: false
          })
        );
        mirror.scale.y = -1;
        world.add(mirror);
        mirrors.push(mirror);

        // Temas gölgesi: yassı, yumuşak, ürünün tam altında.
        var shadow = new THREE.Mesh(
          new THREE.PlaneGeometry(1.9, 1.9),
          new THREE.MeshBasicMaterial({
            map: tightBlob,
            color: 0x000000,
            transparent: true,
            opacity: 0,
            depthWrite: false
          })
        );
        shadow.rotation.x = -Math.PI / 2;
        world.add(shadow);
        shadows.push(shadow);
      });

      start();
    });

    var mx = 0,
      my = 0,
      tmx = 0,
      tmy = 0;

    function onMove(e) {
      var r = canvas.getBoundingClientRect();
      var cx = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
      var cy = (e.touches ? e.touches[0].clientY : e.clientY) - r.top;
      tmx = (cx / r.width - 0.5) * 2;
      tmy = (cy / r.height - 0.5) * 2;
    }
    window.addEventListener('mousemove', onMove, { passive: true });
    canvas.addEventListener('touchmove', onMove, { passive: true });

    function resize() {
      var w = canvas.clientWidth || canvas.parentElement.clientWidth;
      var h = canvas.clientHeight || canvas.parentElement.clientHeight;
      if (!w || !h) return;
      renderer.setSize(w, h, false);
      camera.aspect = w / h;
      camera.updateProjectionMatrix();
    }
    window.addEventListener('resize', resize);

    var running = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (ents) {
          var vis = ents[0].isIntersecting;
          if (vis && !running) {
            running = true;
            loop();
          }
          running = vis;
        },
        { threshold: 0.01 }
      ).observe(canvas);
    }

    var PERIOD = 4.2; // öndeki parçanın sahnede kaldığı süre (sn)
    var t0 = performance.now();

    function loop() {
      if (!running) return;
      requestAnimationFrame(loop);
      var t = (performance.now() - t0) / 1000;

      mx += (tmx - mx) * 0.05;
      my += (tmy - my) * 0.05;

      var front = t / PERIOD;

      for (var i = 0; i < planes.length; i++) {
        var m = planes[i];

        // Ön yuvaya en kısa işaretli uzaklık, [-N/2, N/2] aralığına sarılmış
        var u = i - front;
        u = ((u % N) + N) % N;
        if (u > N / 2) u -= N;
        var au = Math.abs(u);

        var x = u * 1.42;
        var z = -au * 2.75;
        var scale = 1 / (1 + au * 1.05);
        var opacity = Math.max(0, 1 - au * 1.02);

        var bob = Math.sin(t * 0.85 + i) * 0.035 * (1 - au * 0.3);
        /* Taban çizgisi sabit: düzlemin ALT kenarı her ölçekte zemine oturur.
           Kesim görsellerinde çevrede ~%6 boşluk var, PAD onu geri alır —
           yoksa ürün zeminin biraz üstünde asılı kalıyordu. */
        var baseY = FLOOR_Y + (PLANE * scale) / 2 - PLANE * scale * PAD;

        m.position.set(x, baseY + bob, z);
        m.scale.setScalar(scale);
        m.material.opacity = opacity;
        m.renderOrder = 20 - au;
        m.visible = opacity > 0.02;

        // Yalnız öndeki parça canlı: hafif dönüş, imlece tepki.
        var life = smoothstep(0.7, 0, au);
        m.rotation.y = (Math.sin(t * 0.42) * 0.1 + mx * 0.22) * life;
        m.rotation.x = -my * 0.12 * life;

        /* Gölge: ürünün tabanı kadar dar. Ürün yükseldikçe hem büyür hem
           soluklaşır — havada asılı durmadığını anlatan asıl ipucu bu. */
        var sh = shadows[i];
        var lift = smoothstep(0, 0.07, bob + 0.035);
        sh.position.set(x, FLOOR_Y + 0.004, z);
        sh.scale.setScalar(scale * (0.66 + lift * 0.08));
        sh.material.opacity = opacity * 0.42 * (1 - lift * 0.3);
        sh.visible = m.visible;

        /* Yansıma: üst kenarı ürünün taban çizgisine değer, dikey çevrik,
           çok sönük. Yalnız öndeki parçada görünür. */
        var mi = mirrors[i];
        mi.position.set(x, FLOOR_Y - (PLANE * scale) / 2 + PLANE * scale * PAD - bob * 0.5, z);
        mi.scale.set(scale, -scale * 0.58, scale);
        mi.material.opacity = opacity * life * 0.075;
        mi.rotation.y = m.rotation.y;
        mi.visible = mi.material.opacity > 0.01;
        mi.renderOrder = 5;
      }

      // Işık perdesi ve halede çok yavaş bir nefes.
      var breath = 0.5 + 0.5 * Math.sin(t * 0.55);
      curtain.material.opacity = 0.085 + 0.03 * breath;
      backGlow.material.opacity = 0.3 + 0.06 * breath;
      pool.material.opacity = 0.05 + 0.018 * breath;

      world.position.x += (targetOX() - world.position.x) * 0.08;
      var ox = world.position.x;
      camera.position.x += (mx * 0.42 + ox * 0.14 - camera.position.x) * 0.05;
      camera.position.y += (0.35 - my * 0.24 - camera.position.y) * 0.05;
      camera.lookAt(ox * 0.6, -0.15, 0);

      renderer.render(scene, camera);
    }

    function start() {
      resize();
      loop();
    }
  }

  function boot() {
    var canvases = document.querySelectorAll('[data-jv-3d]');
    if (!canvases.length) return;
    if (!hasWebGL() || !window.THREE) {
      canvases.forEach(showFallback);
      return;
    }
    canvases.forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
